* {
  box-sizing: border-box;
}

:host {
  --transition: all 300ms ease-out;
  position: relative;
  display: block;
  aspect-ratio: 375/475;
  border-radius: var(--border-radius, 0);
  background-size: 100%;
  background-position: center center;
  font-family: var(--cwc-font-sans-serif-regular);
  cursor: pointer;
  text-align: var(--text-align, left);
  transition: var(--transition);
  transition-duration: 1000ms;
  overflow: hidden;
}

@media (min-width: 1025px) {
  :host {
    aspect-ratio: 1/1;
  }
}

:host(:hover) {
  background-size: 130%;
}

.tinted-bg {
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: var(--transition);
}

:host(:hover) .tinted-bg {
  opacity: var(--hover-opacity, 0.5);
}

.content-container {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  top: 0;
  padding: 40px 30px;
}

@media (min-width: 1025px) {
  .content-container {
    padding: 15% 12.5%;
  }
}

::slotted(:last-child) {
  margin-top: auto;
}

::slotted(*) {
  color: var(--text-color);
  transition: var(--transition);
}

:host(:hover) ::slotted(*) {
  color: var(--text-color-hover);
}

::slotted(.title) {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 26px;
  line-height: 1.25;
  transition: var(--transition);
}

::slotted(.text) {
  margin-block: 24px;
  opacity: 0;
  transition: var(--transition);
}

:host(:hover) ::slotted(.text) {
  opacity: 1;
}
